import { render, staticRenderFns } from "./CambiarClave.vue?vue&type=template&id=742ff356&scoped=true"
import script from "./CambiarClave.vue?vue&type=script&lang=js"
export * from "./CambiarClave.vue?vue&type=script&lang=js"
import style0 from "./CambiarClave.vue?vue&type=style&index=0&id=742ff356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742ff356",
  null
  
)

export default component.exports